export const ROLES = Object.freeze({
  INVESTOR: 'Investor',
  MANAGER: 'Manager',
  ADMIN: 'Admin',
});
